import { render, staticRenderFns } from "./RootsAndDegrees.vue?vue&type=template&id=1a140ab4&lang=pug&"
import script from "./RootsAndDegrees.vue?vue&type=script&lang=js&"
export * from "./RootsAndDegrees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports